function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,4A16.2,16.2,0,0,0,4,20.4,16.375,16.375,0,0,0,14.943,35.97c.8.15,1.094-.352,1.094-.79,0-.39-.016-1.42-.021-2.787-4.453.988-5.391-2.2-5.391-2.2a4.342,4.342,0,0,0-1.776-2.4c-1.453-1.014.109-.993.109-.993a3.37,3.37,0,0,1,2.448,1.687,3.362,3.362,0,0,0,4.656,1.367,3.564,3.564,0,0,1,1.016-2.195c-3.552-.411-7.286-1.821-7.286-8.106a6.448,6.448,0,0,1,1.646-4.405,6.057,6.057,0,0,1,.156-4.341s1.344-.438,4.4,1.682a14.859,14.859,0,0,1,8.01,0c3.057-2.12,4.4-1.682,4.4-1.682a6.009,6.009,0,0,1,.161,4.341A6.42,6.42,0,0,1,30.2,19.55c0,6.3-3.739,7.684-7.3,8.1a3.959,3.959,0,0,1,1.083,3.033c0,2.195-.016,3.962-.016,4.5,0,.438.286.95,1.1.79A16.378,16.378,0,0,0,36,20.4,16.2,16.2,0,0,0,20,4Z",
  transform: "translate(-4 -4)"
});

var SvgGithub = function SvgGithub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGithub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/github.5f81c3a6.svg";
export { ForwardRef as ReactComponent };